function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  stroke: "var(--primary-color, #000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M14 14.917h24.917c8.376 0 15.167 6.548 15.167 14.625 0 16.792-15.167 14.625-15.167 14.625s8.531-8.136 2.796-14.723C35.667 22.5 14 33.334 14 14.917",
  strokeLinecap: "round",
  strokeLinejoin: "bevel"
}), /*#__PURE__*/React.createElement("path", {
  d: "M22.667 26.075c6.892-.718 10.101-4.686 9.75-11.158M38.917 27.592c6.033-2.04 6.797-6.388 6.5-11.592M43.25 36.583c3.974-.156 7.974-.192 10.833-5.417M6.417 4.083C5.16 11.677 10.213 12.63 14 14.916M1 4.083c.84 12.383 7.732 9.57 13 10.833"
}), /*#__PURE__*/React.createElement("ellipse", {
  transform: "rotate(89.935)",
  cx: 19.814,
  cy: -19.394,
  rx: 1.083,
  ry: 2.708,
  strokeLinecap: "round",
  strokeLinejoin: "bevel"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 19.958,
  cy: 19.792,
  r: 0.542,
  strokeLinecap: "round",
  strokeLinejoin: "bevel"
}), /*#__PURE__*/React.createElement("path", {
  d: "M21.583 25.75c3.25-1.083 3.277-3.467 4.333-5.417"
}), /*#__PURE__*/React.createElement("path", {
  d: "M33.5 46.333c-2.991 0-5.417-2.167-5.417-2.167S30.508 42 33.5 42s5.417 2.166 5.417 2.166-2.425 2.167-5.417 2.167z",
  strokeLinecap: "round",
  strokeLinejoin: "bevel"
}), /*#__PURE__*/React.createElement("path", {
  d: "M41.083 49.583c0 2.991-2.167 5.417-2.167 5.417s-2.166-2.425-2.166-5.417c0-2.991 2.166-5.417 2.166-5.417s2.167 2.425 2.167 5.417z",
  strokeLinecap: "round",
  strokeLinejoin: "bevel"
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M30.25 26.833c-2.025 2.07-3.65 4.087 0 5.417M34.583 26.833c-1.857 1.998-3.776 4.002 0 5.417M38.917 27.917c-.751 1.218-4.48 1.542 0 4.333"
})));

var SvgShrimp = function SvgShrimp(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgShrimp, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Shrimp.8d936b68.svg";
export { ForwardRef as ReactComponent };